import Alpine from 'alpinejs'
import mask from '@alpinejs/mask'

Alpine.plugin(mask)
window.Alpine = Alpine

Alpine.start()

//$(document).ready(function () {

let body = $("body");
let overlay = $("#overlay");

// SET/GET COOKIE
function setCookie(name, value, days) {
  let expires = "";
  if (days) {

    let date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
  let nameEQ = name + "=";
  let ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function smoothScrollingTo(target) {
  $("html,body").animate(
    {
      scrollTop: $(target).offset().top - 150,
    },
    500
  );
}

$("a[href*=\\#]").on("click", function (event) {
  event.preventDefault();
  smoothScrollingTo(this.hash);
});

$(document).on("click", ".toggle-active", function (e) {
  e.stopPropagation();
});

$(window).on("click", function (e) {
  $(".toggle-active").removeClass("toggle-active");
  overlay.fadeOut();
});

$(".phone-mask").inputmask({ mask: "(999) 999-9999" });
$(".select2-select").select2();

// body.on("click", ".contact-show", function () {
//   let block = $(this).closest(".attendance-wrapper").find(".person-contacts");
//   if (block.hasClass("open")) {
//     block.removeClass();
//     block.addClass("person-contacts");
//   } else {
//     block.addClass("open");
//   }
// });
    body.on('click', 'input[name^="student"][name$="[attendance]"]', function(e) {
        var attendanceValue = $(this).val();
        var cameraStatusBlock = $(this).closest('.attendance-group').siblings('.camera-status-block');
        if (attendanceValue == '1') {
            cameraStatusBlock.show();
        } else {
            cameraStatusBlock.hide();
        }
    });

body.on("click", ".show-more-button", function (e) {
  e.preventDefault();

  let moreText = $(this).closest(".trust-us").find(".show-more-text");
  if (moreText.hasClass("show")) {
    moreText.removeClass("show");
  } else {
    moreText.addClass("show");
  }
});

//main menu
$(".categories-list li").on("mouseover", function () {
  $(this)
    .addClass("active")
    .siblings()
    .removeClass("active")
    .closest(".menu-inner")
    .find(".item-content")
    .removeClass("active")
    .eq($(this).index())
    .addClass("active");
});

body.on("click", ".menu-item-courses", function (event) {
  let $this = $(this);
  let modal = $("#courses-menu");
  showModal(event, $this, modal);
});

body.on("click", ".menu-item-languages", function (event) {
  let $this = $(this);
  let modal = $("#languages-menu");
  showModal(event, $this, modal);
});

body.on("click", ".menu-item-about", function (event) {
  let $this = $(this);
  let modal = $("#about-menu");
  showModal(event, $this, modal);
});

$('[data-accordione="no-accordione"]').each(function () {
    $(this).addClass('no-accordion').attr('data-accordione-processed', 'true');
  });

function showModal(event, $this, modal) {
  if ($this.hasClass("toggle-active")) {
    body.find(".toggle-active").removeClass("toggle-active");
    return false;
  }

  body.find(".toggle-active").removeClass("toggle-active");
  $this.toggleClass("toggle-active");
  modal.toggleClass("toggle-active");
}

body.on("click", ".account", function (e) {
  e.preventDefault();
  let $this = $(this);

  if ($this.hasClass("toggle-active")) {
    body.find(".toggle-active").removeClass("toggle-active");
    return false;
  } else {
    body.find(".toggle-active").removeClass("toggle-active");
    $this.addClass("toggle-active");
  }

  $.ajax({
    type: "POST",
    headers: {
      "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
    },
    url: "/crm/user/show-account-login",
    success(result) {
      let modal = $("#account-login");
      modal.html(result["modal"]);
      modal.addClass("toggle-active");
      //$('.phone-mask').inputmask({'mask': '(999) 999-9999'});

      let input = document.querySelector("#login-phone");
      window.intlTelInput(input, {
        initialCountry: "ua",
        hiddenInput: "phone",
        preferredCountries: ["ua", "ru", "by", "kz"],
        utilsScript: "/js/phone/utils.js",
      });
    },
  });
});

body.on("click", ".submit-course-form", function (e) {
  e.preventDefault();
  removeErrors();
  let phoneNumber = "";
  let form = e.target.closest("form");
  const action = form.dataset.action;
  const formData = getData(form);
  const iti = getIntlTelInput();
  iti.forEach((iti) => {
    const currentInput = iti.telInput;
    const currentInputData = currentInput.dataset.phone;
    if (currentInputData === "course") {
      phoneNumber = iti.getNumber();
    }
  });

  const data = {
    ...formData,
    phone: phoneNumber,
  };

  $.ajax({
    type: "POST",
    headers: {
      "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
    },
    data: data,
    url: action,
    success(result) {
      if (result === "success") {
        location.href = "/thank-you";
      }
    },
    error: function (error) {
      setErrors(error);
    },
  });
});

function removeErrors() {
  const errors = document.querySelectorAll(".error-message");
  errors.forEach((error) => {
    error.innerHTML = "";
  });
}

function setErrors(error) {
  const errors = error.responseJSON.errors;
  for (const error in errors) {
    const errorMessage = document.querySelector(`[data-key="${error}"]`);
    errorMessage.innerHTML = "";
    errorMessage.innerHTML = `${errors[error]}`;
  }
}

body.on("click", ".get-offer", function (e) {
  e.preventDefault();
  let $this = $(this);
  let courseId = $(this).data("id");
  let url = $(this).data("url");

  if ($this.hasClass("toggle-active")) {
    body.find(".toggle-active").removeClass("toggle-active");
    return false;
  } else {
    body.find(".toggle-active").removeClass("toggle-active");
    $this.addClass("toggle-active");
  }

  $.ajax({
    type: "POST",
    headers: {
      "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
    },
    data: { id: courseId },
    url: url,
    success(result) {
      let modal = $("#course-modal");
      overlay.fadeIn(400);
      modal.html(result["modal"]);
      modal.addClass("toggle-active");
      const inputs = Array.from($("#phone"));
      inputs.forEach((input) => {
        intlTelInputFunc(input);
      });
      // $(".phone-mask").inputmask({ mask: "(999) 999-9999" });
    },
  });
});

body.on("click", ".menu-lang", function (e) {
  e.preventDefault();
  let $this = $(this);
  let menu = $("#menu-mobile-lang");

  if ($this.hasClass("toggle-active")) {
    body.find(".toggle-active").removeClass("toggle-active");
    return false;
  } else {
    body.find(".toggle-active").removeClass("toggle-active");
    $this.addClass("toggle-active");
    menu.addClass("toggle-active");
  }
});

body.on("click", ".menu-course", function (e) {
  e.preventDefault();
  let $this = $(this);
  let menu = $("#menu-mobile-course");

  if ($this.hasClass("toggle-active")) {
    body.find(".toggle-active").removeClass("toggle-active");
    return false;
  } else {
    body.find(".toggle-active").removeClass("toggle-active");
    $this.addClass("toggle-active");
    menu.addClass("toggle-active");
  }
});

body.on("click", ".menu-mobile-button, .menu-about", function (e) {
  let $this = $(this);
  let menu = $("#menu-mobile-right");

  if ($this.hasClass("toggle-active")) {
    body.find(".toggle-active").removeClass("toggle-active");
  } else {
    body.find(".toggle-active").removeClass("toggle-active");
    $this.addClass("toggle-active");
    menu.addClass("toggle-active");
  }
});

body.on("click", ".show-more-button", function (e) {
  e.preventDefault();
  let $this = $(this);
  let text = $(this).closest(".show-more-text").find(".seo-text");
  let shadow = $(this).closest(".show-more-text").find(".shadow");

  if ($this.hasClass("toggle-active")) {
    body.find(".toggle-active").removeClass("toggle-active");
    return false;
  } else {
    body.find(".toggle-active").removeClass("toggle-active");
    $this.addClass("toggle-active");
    text.addClass("toggle-active");
    shadow.addClass("toggle-active");
  }
});

// ACCORDION
$(".faq-toggle").click(function (e) {
  e.preventDefault();
  let $this = $(this);

  if ($this.next().hasClass("show")) {
    $this.next().removeClass("show");
    $this.next().slideUp(350);
  } else {
    $this.parent().parent().find("li .inner").removeClass("show");
    $this.parent().parent().find("li .inner").slideUp(350);
    $this.next().toggleClass("show");
    $this.next().slideToggle(350);
  }
});

let track = function (category) {
  gtag("event", "click", {
    event_category: category,
  });
};

body.on("click", ".create-pdf", function (e) {
  e.preventDefault();

  let invoiceId = $(this).data("invoice");
  let totalPrice = $(this).data("total");

  $.ajax({
    type: "POST",
    headers: {
      "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
    },
    data: { invoiceId: invoiceId, totalPrice: totalPrice },
    url: "/invoice/pdf",
    success(file) {
      window.open(file);
    },
  });
});

body.on("click", ".show-privat-options", function (e) {
  let $this = $(this);
  let modal = $(".privat-options");
  showModal(e, $this, modal);
});

//Tabs
body.on("click", ".modal-tabs li", function (e) {
  let target = $(this).find("span").data("target");
  $(this).addClass("active").siblings().removeClass("active");
  $(this).closest(".tabs").find(".tab").removeClass("active");
  body.find(target).addClass("active");
});

// body.on("submit", "#free-lesson-form", function(e) {
//     $(this)
//         .find(".errors")
//         .remove();

//     let email = $(this)
//         .find("#login-email")
//         .val();
//     if (!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
//         $(this)
//             .find("#login-email")
//             .closest(".form-group")
//             .append(
//                 '<div class="errors" style="color:red">E-mail введено невірно!</div>'
//             );
//         return false;
//     }
// });

body.on("click", ".control-sidebar-button", function () {
  if ($(this).hasClass("active")) {
    $(this).removeClass("active");
    $(this).closest(".admin-sidebar").removeClass("active");
  } else {
    $(this).addClass("active");
    $(this).closest(".admin-sidebar").addClass("active");
  }
});
body.on("click", ".control-sidebar-help-button", function () {
  if ($(this).hasClass("active")) {
    $(this).removeClass("active");
    $(this).closest(".admin-help-sidebar").removeClass("active");
  } else {
    $(this).addClass("active");
    $(this).closest(".admin-help-sidebar").addClass("active");
  }
});
body.on('click', '.control-sidebar-help-new-button', function () {
  if ($(this).hasClass('active')) {
    $(this).removeClass('active');
    Livewire.emit('closeHelpSidebar');
    $(this).closest('.admin-help-new-sidebar').removeClass('active');
  } else {
    $(this).addClass('active');
    Livewire.emit('openHelpSidebar');
    $(this).closest('.admin-help-new-sidebar').addClass('active');
  }
});
body.on('click', '.control-sidebar-courses-button', function () {
    let button = $(this);
    let sidebar = button.closest('.admin-courses-sidebar');
    let content = sidebar.find('.control-sidebar-courses-content');

    if (button.hasClass('active')) {
      button.removeClass('active');
      sidebar.removeClass('active');
    } else {
      button.addClass('active');
      sidebar.addClass('active');

      let content = $('.control-sidebar-courses-content');

        $.ajax({
          type: 'POST',
          headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
          },
          url: '/program/show-widget',
          success(result) {
            if (result.status) {
              content.html(result.body);

              content.find('.admin-sidebar-accordion').accordionjs({
                activeIndex: false,
              });

              content.find('.admin-sidebar-accordion-subcategory').accordionjs({
                activeIndex: false,
              });

              content.find('.admin-sidebar-accordion-message').accordionjs({
                activeIndex: false,
              });

              content.find('.admin-sidebar-direction-accordion').accordionjs({
                activeIndex: false,
              });

            } else {
              content.html('<div class="text-danger">Помилка завантаження даних</div>');
            }
          },
          error() {
            content.html('<div class="text-danger">Помилка підключення до сервера</div>');
          }
        });
    }
  });

let asa = $("#admin-sidebar-accordion");
if (asa.length > 0) {
  asa.accordionjs({
    activeIndex: false,
  });
}
let asac = $("#admin-sidebar-courses-accordion");
if (asac.length > 0) {
    asac.accordionjs({
        activeIndex: false,
    });
}

let adac = $(".admin-sidebar-direction-accordion");
if (adac.length > 0) {
    adac.each(function () {
        $(this).accordionjs({
            activeIndex: false,
        });
    });
}


let asal = $("#admin-sidebar-accordion-inner");
if (asal.length > 0) {
  asal.accordionjs({
    activeIndex: false,
  });
}

// Tests

body.on("click", ".start-test-button", function (e) {
  let url = window.location.href;
  let urlPath = url.split("/");
  if (
    getLocalStorageItem(urlPath[4]) &&
    getLocalStorageItem(urlPath[4]).test === "pass"
  ) {
    let result = getLocalStorageItem(urlPath[4]).result;
    overlay.fadeIn(400);
    let modal = body.find("#test-form-submit");
    showModal(e, $(this), modal);
    modal.html(
      '<div class="title">Ви вже пройшли цей тест </br> Ваш результат: </div>' +
        '<div class="result">' +
        result +
        " " +
        score(result) +
        "</div>"
    );
    return false;
  }

  $(".test-description").addClass("hidden");
  $(this).addClass("hidden");
  let task = body.find(".test-from-task").first();
  task.addClass("show");
});

body.on("click", ".next-task-button", function (e) {
  let task = $(this).closest(".test-from-task");
  let chosen = task.find("input[type=radio]:checked");
  if (chosen.length < 1) {
    let modal = body.find("#error");
    showModal(e, $(this), modal);
    return false;
  }

  let next = task.next();
  if (next.length > 0) {
    task.removeClass("show");
    next.addClass("show");
  }

  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });

  let url = window.location.href;
  let slug = url.split("/");
  trackProgress(slug[slug.length - 1]);
});

body.on("click", ".prev-task-button", function (e) {
  let task = $(this).closest(".test-from-task");
  let prev = task.prev();
  if (prev.length > 0) {
    task.removeClass("show");
    prev.addClass("show");
  }
});

// body.on("click", ".result-button", function (e) {
//   e.preventDefault();

//   overlay.fadeIn(400);
//   let modal = body.find("#test-form-submit");
//   showModal(e, $(this), modal);
// });

body.find("#free-lesson-form").submit(function (e) {
  e.preventDefault();
  removeErrors();
  let phoneNumber = "";
  let form = e.target.closest("form");
  const url = form.dataset.action;

  const formData = getData(form);
  const iti = getIntlTelInput();
  iti.forEach((iti) => {
    const currentInput = iti.telInput;
    const currentInputData = currentInput.dataset.phone;
    if (currentInputData === "free-lesson") {
      phoneNumber = iti.getNumber();
    }
  });

  const data = {
    ...formData,
    phone: phoneNumber,
  };

  $.ajax({
    type: "POST",
    headers: {
      "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
    },
    data: data,
    url: url,
    success(result) {
      if (result.status) {
        window.location.href = result.redirect_url;
      } else {
        const errorMessageSpan = $('.error-message[data-key="error_message"]');
        errorMessageSpan.text(result.error_message);
      }
    },
    error: function (error) {
      setErrors(error);
    },
  });
});

body.find("#test-form-submit").submit(function (e) {
  e.preventDefault();
  removeErrors();
  // let form = body.find("#test-form-submit-form");
  let phoneNumber = "";
  let form = e.target.closest("form");
  $(form).find(".my-button").prop("disabled", true);
  const action = form.dataset.action;
  const formData = getData(form);
  const iti = getIntlTelInput();
  iti.forEach((iti) => {
    const currentInput = iti.telInput;
    const currentInputData = currentInput.dataset.phone;
    if (currentInputData === "test-form") {
      phoneNumber = iti.getNumber();
    }
  });

  const data = {
    ...formData,
    phone: phoneNumber,
  };

  let testForm = body.find("#test-from");

  let page = testForm.find("#page");
  let direction = testForm.find("#direction");
  data.page = page.val();
  data.direction = direction.val();

  $.ajax({
    type: "POST",
    headers: {
      "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
    },
    data: data,
    url: "/test-lead",
    success(result) {
      body.find(".test-from-task.show").html(result["result_html"]);
      let modal = body.find("#test-form-submit");
      modal.removeClass("toggle-active");
      $(form).find(".my-button").prop("disabled", false);
      overlay.fadeOut(400);

      let obj = {
        test: "pass",
        result: result["result"],
      };
      let url = window.location.href;
      let urlPath = url.split("/");
      setLocalStorageItem(urlPath[4], obj, 60 * 60 * 24 * 1000);
    },
    error: function (error) {
      setErrors(error);
      $(form).find(".my-button").prop("disabled", false);
    },
  });
});

$('body').on('click', '.copy-link', function (e) {
    e.preventDefault();

    // Створення textarea замість input
    let tempTextarea = document.createElement('textarea');
    tempTextarea.style.position = 'absolute';
    tempTextarea.style.left = '-1000px';
    tempTextarea.style.top = '-1000px';
    tempTextarea.value = $(this).data('link');

    // Додавання textarea до документа
    document.body.appendChild(tempTextarea);
    tempTextarea.select();

    // Виконання команди копіювання
    document.execCommand('copy');

    // Видалення textarea з документа
    document.body.removeChild(tempTextarea);

    toastr.success('Збережено в буфер!');
  });


  body.on('click', '.show-group-students', function (e) {
    e.preventDefault();
    let groupId = e.target.dataset.groupId;

    $.ajax({
      type: 'POST',
      headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
      },
      url: '/account/show-group-students',
      data: { groupId: groupId },
      success: function (result) {
        if (result['error'] && result['error'] === 'access-denied') {
          let modal = body.find('#modal-danger');
          modal.modal();
          modal.find('.modal-title').html(result['title']);
          modal.find('.modal-body').html(result['body']);
          modal.find('.modal-footer').html(result['footer']);
        } else {
          let modal = body.find('#modal-lg');
          modal.modal();
          modal.find('.modal-title').html(result['head']);
          modal.find('.modal-body').html(result['body']);
          modal.find('.modal-footer').html(result['footer']);
        }
      },
    });
  });

    body.on('click', '.track-event', function (e) {
        if (e.ctrlKey || e.metaKey || e.button === 1) return;

        e.preventDefault();

        const href = $(this).attr('href') || $(this).data('url');
        // try {
        //     tgp('event', eventId);
        // } catch (err) {
        //     console.warn('tgp не знайдено або не ініціалізований:', err);
        // }

        if (href && href !== '#') {
            setTimeout(() => {
                if ($(this).data('url')) {
                    window.open(href, '_blank');
                } else {
                    window.location.href = href;
                }
            }, 150);
        }
    });

    // body.on('click', '.track-teacher-event', function (e) {
    //     if (e.ctrlKey || e.metaKey || e.button === 1) return;

    //     e.preventDefault();
    //     const href = $(this).attr('href');

    //     try {
    //         tgp('event', 'k1qWTd06-jFdf17nc');
    //     } catch (err) {
    //         console.warn('tgp не знайдено або не ініціалізований:', err);
    //     }

    //     if (href && href !== '#') {
    //         setTimeout(() => {
    //             window.location.href = href;
    //         }, 150);
    //     }
    // });
body.find("#test-from").submit(function (e) {
  e.preventDefault();

  let url = window.location.href;
  let urlPath = url.split("/");
  if (
    getLocalStorageItem(urlPath[4]) &&
    getLocalStorageItem(urlPath[4]).test === "pass"
  ) {
    let result = getLocalStorageItem(urlPath[4]).result;

    overlay.fadeIn(400);
    let modal = body.find("#test-form-submit");
    showModal(e, $(this), modal);

    modal.html(
      '<div class="title">Ви вже пройшли цей тест </br> Ваш результат: </div>' +
        '<div class="result">' +
        result +
        " " +
        score(result) +
        "</div>"
    );
    return false;
  }

  let form = body.find("#test-from");
  let visitorId = getCookie("visitor-id");
  let data = form.serialize() + '&visitor_id=' + visitorId;

  $.ajax({
    type: "POST",
    headers: {
      "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
    },
    data: data,
    url: "/test",
    success(result) {
      // modal.hide();
      // overlay.fadeOut();
      // form[0].reset();
      //   let container = body.find(".test-from-task.show");
      //   container.html(result["html"]);

      if (result.status) {
        overlay.fadeIn(400);
        let modal = body.find("#test-form-submit");
        showModal(e, $(this), modal);

        // subForm.append(
        //   '<input type="hidden" name="result" value="' +
        //     result["result"] +
        //     '"/>'
        // );
      }
    },
  });
});

function score(result) {
  result = parseInt(result);
  let lastDigit = parseInt(result) % 10;
  let word;

  if (lastDigit === 1 && result !== 11) {
    word = "бал";
  } else if (lastDigit === 2 && result !== 12) {
    word = "бала";
  } else if (lastDigit === 3 && result !== 13) {
    word = "бала";
  } else if (lastDigit === 4 && result !== 14) {
    word = "бала";
  } else {
    word = "балів";
  }

  return word;
}

function setLocalStorageItem(key, value, ttl) {
  let item = {
    value: value,
    expiry: ttl ? Date.now() + ttl : null,
  };

  localStorage.setItem(key, JSON.stringify(item));
}

function getLocalStorageItem(key) {
  let item = localStorage.getItem(key);
  if (!item) return null;
  item = JSON.parse(item);
  if (item.expiry && Date.now() > item.expiry) {
    localStorage.removeItem(key);
    return null;
  }

  return item.value;
}

// test track progress
function trackProgress(slug) {

    let form = body.find("#test-from");
    let cookie = +getCookie(slug) + 1;
    let visitorId = getCookie("visitor-id");
    let data = form.serialize() + '&visitor_id=' + visitorId + '&slug=' + slug + '&step=' + cookie;

    // save progress
    $.ajax({
        type: "POST",
        headers: {
            "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
        },
        data: data,
        url: "/test/set-progress",
        success(result) {
            if (result.url) {

                // старе
                let testFormTask = $('.test-from-task');
                testFormTask.find('a').attr('href', result.url);

                // нове
                $('a.telegram-url').each(function () {
                    $(this).attr('href', result.url);
                });
            }
        },
    });

    setCookie(slug, cookie.toString(), 1);
}

Livewire.on('openModal', () => {
    const chatBlocks = document.querySelectorAll(
      '[data-chat="blocks-accordion"]'
    );

    chatBlocks.forEach((blocks) => initOpen(blocks));

    const messages = document.querySelectorAll('.chat-message');
    if (messages?.length > 0) {
      const lastMessage = messages[messages.length - 1];
      lastMessage.scrollIntoView({
        block: 'start',
        inline: 'start',
      });
    }

    let timer = setTimeout(() => {
      const scrolledList = document.querySelector(
        '[data-list="scroll-messages"]'
      );
      loadNewItems(scrolledList, 'first', 'reduceNotificationLimit');
      clearTimeout(timer);
    }, 100);
  });

import { getIntlTelInput, intlTelInputFunc } from "./intl-tel-input/intl-mask";
import { getData } from "./helpers/formData";

//});
import "./login-teacher";
import "./inputMask";
import "./tasks";
import "./pusher";
import "./teacher-form";
import "./youtube-video";
import "./intl-tel-input/intl-mask";
import "./modal";
import "./free-lesson-modal/index";
import "./free-lessson-checked";
import '../notifications/js/app';


